module.exports = __webpack_public_path__ + "static/media/notification_icon_dark.d94af49d.png";